module.exports = __webpack_public_path__ + "static/rhombus-fddfe055c2c90c1c25fc9276e7d6b895.svg";